import { render, staticRenderFns } from "./NetworkAlliancePage.vue?vue&type=template&id=0218a59a&scoped=true"
import script from "./NetworkAlliancePage.vue?vue&type=script&lang=js"
export * from "./NetworkAlliancePage.vue?vue&type=script&lang=js"
import style0 from "./NetworkAlliancePage.vue?vue&type=style&index=0&id=0218a59a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0218a59a",
  null
  
)

export default component.exports